/**
 * @generated SignedSource<<67a08d1c1c07c0e1213cf87a7a074f86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoginUserInput = {
  password: string;
  usernameOrEmail: string;
};
export type LoginPageUserMutation$variables = {
  input: LoginUserInput;
};
export type LoginPageUserMutation$data = {
  readonly loginUser: {
    readonly node: {
      readonly id: string;
    };
  };
};
export type LoginPageUserMutation = {
  response: LoginPageUserMutation$data;
  variables: LoginPageUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserEdge",
    "kind": "LinkedField",
    "name": "loginUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginPageUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginPageUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "69756bb13f3299fa2d6b0b0c841a001d",
    "id": null,
    "metadata": {},
    "name": "LoginPageUserMutation",
    "operationKind": "mutation",
    "text": "mutation LoginPageUserMutation(\n  $input: LoginUserInput!\n) {\n  loginUser(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "577f1c2f4f0471732bffc084e8cf39ae";

export default node;
